<template>
	<AsiCardDetail :title="$t('user.state')" :icon="icons.state"
	               :show-action-button="!readonly" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :icon="icons.state" :label="$t('user.state')">
			<UserStateChip :user="user"/>
		</AsiCardDetailEntry>

		<UserUpdateDialogState v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen" :user="user"
		                       @cancel="updateDialog.close()" @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop} from "vue-property-decorator";
	import {IUserShop} from "@/models/user/UserShopModels";
	import {IUserAdmin} from "@/models/user/UserAdminModels";
	import Icon from "@/plugins/icons";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import UserUpdateDialogState from "@/components/user/admin/UserUpdateDialogState.vue";
	import DialogHandler from "@/components/common/DialogHandler";
	import UserStateChip from "@/components/user/UserStateChip.vue";

	@Component({
		components: {UserStateChip, UserUpdateDialogState, AsiCardDetailEntry, AsiCardDetail}
	})
	export default class UserCardState extends Vue {

		@Prop({type: Object, required: true})
		public user!: IUserShop | IUserAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private icons = Icon;
		private updateDialog: DialogHandler = new DialogHandler();

		@Emit('change')
		public change(): void {
			return;
		}

	}
</script>

<style lang="scss" scoped>

</style>
